import React from 'react';
import Button from 'devextreme-react/button';

import DataItemView from '../../../common/view/DataItemView';

import ContractRangeView from './ContractRangeView';

export default class ContractRangeListView extends DataItemView {
  static displayName = ContractRangeListView.name;

  constructor(props) {
    super(props);

    this.createContractRangeListener = this.onCreateContractRange.bind(this);
    this.removeContractRangeListener = this.onRemoveContractRange.bind(this);

    this.bindDataItem(props.contractRangeList);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.contractRangeList);
  }

  render() {
    if (!this.state.isDataBound)
      return (<div />);

    return (
      <div className="pwx-contract-range-list-view">
        <div className="pwx-contract-range-list-title">CONTRACT RANGES</div>
        <div className="pwx-contract-range-list-content">
          <table hidden={this.state.dataObjects.length === 0} ><tbody>
            <tr>
              <td colSpan="3">Start Date:</td>
              <td colSpan="3">End Date:</td>
              <td colSpan="3">Viewer Role:</td>
              <td colSpan="3">Editor Role:</td>
              <td colSpan="1"></td>
            </tr>
            {
              this.state.dataObjects.map(
                contractRange => (<ContractRangeView key={contractRange.key} contractRange={contractRange} onRemoveContractRange={this.removeContractRangeListener} />)
              )
            }
          </tbody></table>
          <div className="pwx-contract-range-list-command">
            <Button type="normal" text="Add Contract Range" onClick={this.createContractRangeListener} />
          </div>
        </div>
      </div>
    );
  }

  onCreateContractRange() {
    if (this.dataItem === null)
      return;

    this.dataItem.insertNewDataObject();
  }

  onRemoveContractRange(contractRange) {
    if (this.dataItem === null)
      return;

    if (contractRange.isNew)
      this.dataItem.removeDataObject(contractRange);
    else
      contractRange.setIsDeleted(true);
  }
}